<template>
  <y-wrapper @back="goBack">
    <template slot="nav">
      <div class="navWrap">
        <div class="title-btns navTitle">
          <router-link to="address_model">
            <div class="btn">培训举办地管理</div>
          </router-link>
          <router-link to="heigh_class_list">
            <div class="btn active">高端培训班招标管理</div>
          </router-link>
        </div>
      </div>
    </template>

    <template slot="main">
      <div class="dMain">
        <div class="searchWrap">
          <div class="selectWrap">
            <select id="city" v-model="search.plan_level" @change="getRequest">
              <option value="">全部级别</option>
              <option
                v-for="(item, index) in quaLevelList"
                :key="index"
                :value="item.value"
              >
                {{ item.key }}
              </option>
            </select>
          </div>
          <div class="search">
            <div class="wrap">
              <input
                type="text"
                placeholder="请输入搜索内容"
                v-model.lazy="search.keywords"
                @keyup.enter="getRequest"
              />
              <div
                v-show="search.keywords != ''"
                class="close"
                @click="hideIcon"
              >
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
            </div>
            <div class="searchBtn" @click="getRequest">搜索</div>
          </div>
        </div>

        <div class="content-box">
          <yioks-loading v-show="isLoading"></yioks-loading>
          <template v-if="!isLoading && !pageList.length">
            <yioks-empty h="450px"></yioks-empty>
          </template>
          <template v-if="pageList.length">
            <div class="plane-list">
              <vue-scroll :ops="ops">
                <div class="scroll-content">
                  <div
                    class="plane-item"
                    v-for="(item, index) in pageList"
                    :key="index"
                  >
                    <div class="left">
                      <div class="">
                        {{ item.plan_name }}
                        <!-- <span v-if="item.plan_type"
                          >({{ item.plan_type | heightClassPlane }})</span
                        > -->
                      </div>
                      <div class="title-2">
                        <span>截止时间：{{ item.end_date | time(false) }}</span>
                        <span class="ml15">等级： {{ item.plan_level }}级</span>
                      </div>
                    </div>
                    <div class="right" :data-end="item.end_date">
                      <template>
                        <el-button
                          v-if="isSigned(item.record_status)"
                          type="primary"
                          size="mini"
                          @click="handleViewSignPlan(item)"
                          >查看投标</el-button
                        >

                        <el-button
                          v-if="istimeOver(item.end_date)"
                          type="info"
                          disabled
                          size="mini"
                          >点击投标</el-button
                        >

                        <el-button
                          v-if="
                            !istimeOver(item.end_date) &&
                            isSigned(item.record_status)
                          "
                          type="danger"
                          size="mini"
                          @click="handleCancelPlane(item)"
                          >撤销投标</el-button
                        >
                        <el-button
                          v-if="
                            !istimeOver(item.end_date) &&
                            !isSigned(item.record_status)
                          "
                          type="primary"
                          size="mini"
                          @click="handleSignPlane(item)"
                          >点击投标</el-button
                        >
                      </template>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
            <div id="paging">
              <yioks-paging
                :paging="paging"
                @goto-page="gotoPage($event)"
              ></yioks-paging>
            </div>
          </template>
        </div>
      </div>
      <!-- 状态修改提示 -->
      <y-tips
        :showTips="isShowActionTips"
        :tips="'确认撤销投标？'"
        @hideTips="handleConfirmDoAction"
      ></y-tips>
    </template>
  </y-wrapper>
</template>

<script>
import {
  getHeighClassPlaneList,
  toggleSignStatus,
} from "@/api/system_manager/api";
import ops from "@/assets/js/vuescrollOption";
import { heightClassPlane } from "@/assets/js/yioksFilters";
import { isTimeBefore } from '@/assets/js/utils';

export default {
  data() {
    const quaLevelList = [
      { key: "A级", value: "A" },
      { key: "B级", value: "B" },
    ];
    return {
      quaLevelList,
      ops: ops(),
      search: {
        plan_level: "",
        keywords: "",
      },

      page: 1,
      pageSize: 20,
      isLoading: false,
      pageList: [],
      paging: {
        start: 0, // 每页从第几条数据开始
        prePage: 20, // 一页多少条数据
        total: 0, // 总页数
        size: 3, // 页码显示限制
        last: true, // 尾页
        next: true, // 下一页
        first: true, // 首页
        previous: true, // 上一页
        jump: true,
      },
      actionRows: null,
      isShowActionTips: false,
    };
  },

  filters: {
    heightClassPlane,
  },

  components: {
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
  },

  created() {
    this.loadPageList();
  },

  methods: {
    goBack() {
      this.$router.push({
        path: "training_course_list",
      });
    },
    getRequest() {
      this.changeQuery(true);
    },
    changeQuery(flag) {
      if (flag) {
        this.page = 1;
        this.pageList = [];
      }
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...this.search,
          page: this.page,
        },
      });
      this.loadPageList();
    },
    hideIcon() {
      this.$set(this.search, "keywords", "");
      this.getRequest();
    },

    loadPageList() {
      const { page, keywords, plan_level } = this.$route.query;
      const queryData = {
        page: page || 1 ,
        keywords,
        plan_level,
      };
      this.isLoading = true;
      getHeighClassPlaneList(queryData)
        .then(({ data }) => {
          this.isLoading = false;
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { list, page } = data.result;
          this.pageList = list;
          this.paging = Object.assign({}, this.paging, {
            prePage: page.page_size,
            total: page.total_row,
            start: (this.page - 1) * this.paging.prePage,
          });
        })
        .catch((err) => {
          this.isLoading = false;
          console.error("err", err);
        });
    },

    handleSignPlane(row) {
      const { plan_uuid } = row;
      this.$router.push({
        path: "sign_plane",
        query: {
          plan_uuid: plan_uuid,
        },
      });
    },

    handleViewSignPlan(row) {
      const { plan_uuid } = row;
      this.$router.push({
        path: "sign_plane",
        query: {
          plan_uuid: plan_uuid,
          isView: "1"   // ': 仅查看模式
        },
      });
    },

    handleCancelPlane(row) {
      console.log(row);
      this.actionRows = row;
      this.isShowActionTips = true;
    },
    // 报名状态修改
    handleConfirmDoAction(val, sure) {
      if (sure) {
        const { plan_uuid } = this.actionRows;
        const queryData = {
          plan_uuid: plan_uuid,
          type: "back",
        };
        toggleSignStatus(queryData)
          .then(({ data }) => {
            this.isShowActionTips = false;
            if (data.status !== 0) {
              this.$message.error(data.msg);
              return;
            }
            this.$message.success("操作成功！");
            this.loadPageList();
          })
          .catch((err) => {
            this.isShowActionTips = false;
            console.error("err", err);
          });
      }
      this.isShowActionTips = val;
    },
    istimeOver(val) {
      const dayTime = new Date().getTime();
       return isTimeBefore(val, dayTime, 'day');
      // if (Number(val) < new Date().getTime()) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    isSigned(val) {
      if (val == "submit") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/defaultPage'
.plane-list
  height 510px
  width 100%
  padding 15px 10px 10px
  font-size $font_size_medium
  .scroll-content
    margin 0 20px
    .plane-item
      border-bottom 1px solid #fff
      padding 10px 15px 10px
      margin 10px 10px 10px
      display flex
      justify-content space-between
      .right
        width 180px
        display flex
        align-items center
      .left
        display flex
        flex-direction column
        justify-content space-around
        .title-2
          color $color_info
          font-size $font_size_small
          margin-top 5px
.mr10
  margin-right 10px
.ml15
  margin-left 15px
</style>
